import type { ReactNode } from 'react'
import s from './CardGrid.module.scss'

/**
 * Das Raster für Karten.
 *
 * Karten setzen ihre Breite selbst über `span` — das Raster hält nur die zwölf
 * Spalten und den Abstand. Damit lässt sich ein Dashboard bauen, ohne dass die
 * Seite je Karte Breiten ausrechnet.
 */
export function CardGrid({ children }: { children: ReactNode }) {
  return <div className={s.grid}>{children}</div>
}
